
import AboutPage from './pages/AboutPage';
import Homepage from './pages/Homepage';
import { BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Header from './components/Header';
import Marketplace from './pages/Marketplace';
// import Faq from './pages/faq/Faq';
import Footer from './components/Footer';
import RatesPage from './pages/RatesPage';
import Faqpage from './pages/Faqpage';
import Partnerspage from './pages/Partnerspage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Modal from './components/Modal';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
		<div className="app">
			<Router>
				<Header />
				<Switch>
					<Route path="/" exact component={Homepage} />
					<Route path="/about-us" component={AboutPage} />
					<Route path="/market-place" component={Marketplace} />
					<Route path="/partners" component={Partnerspage} />
					<Route path="/faq" component={Faqpage} />
					<Route path="/rates" component={RatesPage} />
					<Route path="/privacy_policy" component={PrivacyPolicy} />
					<Route path="*" component={NotFoundPage} />
				</Switch>
				<Modal />
				<Footer />
			</Router>
		</div>
	);
}

export default App;
